module.exports = __webpack_public_path__ + "img/cart.588ba887.svg";